import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/finally';

import { Alert, BreadcrumbItem } from '../../../entities/index';
import { TrackerService } from '../../../services/tracker.service';
import { Log } from '../../../utils/index';
import { IsoDateToStringPipe } from '../../../pipes/iso-date-to-string.pipe';


@Component({
  selector: 'app-tracker-alert',
  templateUrl: './alert-list.html'
})
export class AlertListComponent implements OnInit {

  trackerId: number;
  alerts: Alert[];
  startDate: moment.Moment;
  endDate: moment.Moment;
  selectedDate: Date;
  loading = false;

  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('Tracker List', 'map-marker', '/tracker'),
    new BreadcrumbItem('Tracker Detail', 'map-marker'),
    new BreadcrumbItem('Alerts', 'map-marker')
  ];
  pageTitle = 'Alerts Tracker #';
  titleSubText = '';

  constructor(protected route: ActivatedRoute,
              protected trackerService: TrackerService) {
    this.trackerId = Number(route.snapshot.params.id);
    this.pageTitle += this.trackerId;
    this.breadcrumbs[1].link = '/tracker/' + this.trackerId;
    this.breadcrumbs[1].title += ' #' + this.trackerId;
  }

  @Log()
  ngOnInit() {
    this._loadAlerts();
  }

  @Log()
  onDayChange() {
    this._loadAlerts();
  }

  _loadAlerts() {
    let initFilters: any = {start: moment().startOf('day').toISOString(), end: moment().endOf('day').toISOString()};

    if (this.selectedDate) {
      this.startDate = moment(this.selectedDate).startOf('day');
      this.endDate = moment(this.selectedDate).endOf('day');
      initFilters = {
        start: this.startDate.toISOString(),
        end: this.endDate.toISOString()
      };
    }
    const isoDatePipe = new IsoDateToStringPipe();
    this.titleSubText = `From ${isoDatePipe.transform(initFilters.start)} to `;
    this.titleSubText += isoDatePipe.transform(initFilters.end);

    this.loading = true;
    this.trackerService.getAlerts(this.trackerId, initFilters).subscribe(
      (res: Alert[]) => {
        this.alerts = res;
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/alert/alert-list.component.ts